import { Component, OnInit } from '@angular/core';
import { AuthService } from './../auth/auth.service';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-googlesnakey',
  templateUrl: './googlesnakey.component.html',
  styleUrls: ['./googlesnakey.component.css'],
})
export class GooglesnakeyComponent implements OnInit {
  proSnkGraph: any;
  snkGraphJson: any;
  snkString: any;
  heating_loads_roofs: any;
  heating_loads_floors: any;
  heating_loads_internal_conduction_gain: any;
  heating_loads_external_walls: any;
  heating_loads_windows: any;
  heating_loads_Fresh_air_gain: any;
  heating_loads_infiltration_gain: any;
  heating_loads_solar_gain: any;
  heating_loads_equipment_gain: any;
  heating_loads_lighting_gain: any;
  cooling_loads_solar_gain: any;
  cooling_loads_external_walls: any;
  cooling_loads_windows: any;
  cooling_loads_floors: any;
  cooling_loads_roofs: any;
  cooling_loads_Fresh_air_gain: any;
  cooling_loads_internal_conduction_gain: any;
  cooling_loads_lighting_gain: any;
  cooling_loads_equipment_gain: any;
  cooling_loads_infiltration_gain: any;
  total_heating_load: any;
  total_cooling_load: any;
  cooling_loads_people_gain: any;
  heating_loads_internal_conduction_gai;
  gtDat: any;
  j: any;
  d: any;
  pickNode: any;
  dataAvail: boolean = false;
  cellmessage;
  solarGai: boolean;
  apiloaded: boolean = false;
  cellSevenmessage;
  rootDomainUrl = 'http://adeos.io/';
  celsev;
  // rootDomainUrl  ='http://52.60.65.225/';
  constructor(
    private authService: AuthService,
    private router: Router,
    private http: HttpClient
  ) {
    //this.loadScripts();
  }

  chartHeatingSolar() {
    document.getElementById('heatingbtn').style.border = '1px solid #ccc';
    document.getElementById('heatingbtn').style.borderRadius =
      '6px 6px 0px 0px';
    document.getElementById('heatingbtn').style.borderBottom = 'none';
    document.getElementById('heatingbtn').style.color = '#000';
    document.getElementById('coolingbtn').style.backgroundColor = '#fff';
    document.getElementById('coolingbtn').style.color = '#4682b4';
    document.getElementById('coolingbtn').style.border = 'none';
    document.getElementById('coolingbtn').style.borderBottom = '1px solid #ccc';

    // Google Sankey enable block
    document.getElementById('heatingdivider').style.display = 'block';
    document.getElementById('coolingdivider').style.display = 'none';
    document.getElementById('chartsix').style.display = 'none';
    document.getElementById('chartcooling').style.display = 'none';

    // Google Sankey enable block
    document.getElementById('heatingLoad').style.display = 'block';
    // Google Sankey enable block
    document.getElementById('heating').style.display = 'block';
    document.getElementById('coolingLoad').style.display = 'none';
  }

  /*  loadScripts() {
    const dynamicScripts = [
      './assets/sankeylib.js'
      
     ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
    
  }
 */

  stripHTML(text) {
    return text.replace(' ', '___');
  }

  
  snkfun() {
    google.charts.load('current', { packages: ['sankey'] });
    google.charts.setOnLoadCallback(drawChartSankey);
    function drawChartSankey() {
      var datanew = new google.visualization.DataTable();
      datanew.addColumn('string', 'From');
      datanew.addColumn('string', 'To');
      datanew.addColumn('number', 'Weight');
      datanew.addRows([
        ['Brazil', 'Portugal', 5],
        ['Brazil', 'France', 1],
        ['Brazil', 'Spain', 1],
        ['Brazil', 'England', 1],
        ['Canada', 'Portugal', 1],
        ['Canada', 'France', 5],
        ['Canada', 'England', 1],
        ['Mexico', 'Portugal', 1],
        ['Mexico', 'France', 1],
        ['Mexico', 'Spain', 5],
        ['Mexico', 'England', 1],
        ['USA', 'Portugal', 1],
        ['USA', 'France', 1],
        ['USA', 'Spain', 1],
        ['USA', 'England', 5],
        ['Portugal', 'Angola', 2],
        ['Portugal', 'Senegal', 1],
        ['Portugal', 'Morocco', 1],
        ['Portugal', 'South Africa', 3],
        ['France', 'Angola', 1],
        ['France', 'Senegal', 3],
        ['France', 'Mali', 3],
        ['France', 'Morocco', 3],
        ['France', 'South Africa', 1],
        ['Spain', 'Senegal', 1],
        ['Spain', 'Morocco', 3],
        ['Spain', 'South Africa', 1],
        ['England', 'Angola', 1],
        ['England', 'Senegal', 1],
        ['England', 'Morocco', 2],
        ['England', 'South Africa', 7],
        ['South Africa', 'China', 5],
        ['South Africa', 'India', 1],
        ['South Africa', 'Japan', 3],
        ['Angola', 'China', 5],
        ['Angola', 'India', 1],
        ['Angola', 'Japan', 3],
        ['Senegal', 'China', 5],
        ['Senegal', 'India', 1],
        ['Senegal', 'Japan', 3],
        ['Mali', 'China', 5],
        ['Mali', 'India', 1],
        ['Mali', 'Japan', 3],
        ['Morocco', 'China', 5],
        ['Morocco', 'India', 1],
        ['Morocco', 'Japan', 3],
      ]);

      // Set chart options
      var options = {
        width: 400,
      };

      // Instantiate and draw our chart, passing in some options.
      var chartsn = new google.visualization.Sankey(
        document.getElementById('sankey_multiple')
      );
      chartsn.draw(datanew, options);
    }
  }
  snkoadgr() {
    var units = 'Widgets';

    var margin = { top: 10, right: 10, bottom: 10, left: 10 },
      width = 500 - margin.left - margin.right,
      height = 300 - margin.top - margin.bottom;

    var formatNumber = d3.format(',.0f'), // zero decimal places
      format = function (d) {
        return formatNumber(d) + ' ' + units;
      },
      color = d3.scale.category20();

    // append the svg canvas to the page
    var svg = d3
      .select('#chartsix')
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    // Set the sankey diagram properties
    var sankey = d3
      .sankey()
      .nodeWidth(36)
      .nodePadding(40)
      .size([width, height]);

    var path = sankey.link();

    // load the data (using the timelyportfolio csv method)
    d3.csv('assets/sankey.csv', function (error, data) {
      var graph;
      //set up graph in same style as original example but empty
      graph = { nodes: [], links: [] };

      data.forEach(function (d) {
        graph.nodes.push({ name: d.source });
        graph.nodes.push({ name: d.target });
        graph.links.push({
          source: d.source,
          target: d.target,
          value: +d.value,
        });
      });

      // return only the distinct / unique nodes
      graph.nodes = d3.keys(
        d3
          .nest()
          .key(function (d) {
            return d.name;
          })
          .map(graph.nodes)
      );

      // loop through each link replacing the text with its index from node
      graph.links.forEach(function (d, i) {
        graph.links[i].source = graph.nodes.indexOf(graph.links[i].source);
        graph.links[i].target = graph.nodes.indexOf(graph.links[i].target);
      });

      //now loop through each nodes to make nodes an array of objects
      // rather than an array of strings
      graph.nodes.forEach(function (d, i) {
        graph.nodes[i] = { name: d };
      });

      sankey.nodes(graph.nodes).links(graph.links).layout(32);

      // add in the links
      var link = svg
        .append('g')
        .selectAll('.link')
        .data(graph.links)
        .enter()
        .append('path')
        .attr('class', 'link')
        .attr('d', path)
        .style('stroke-width', function (d) {
          return Math.max(1, d.dy);
        })
        .style('fill', 'none')
        .sort(function (a, b) {
          return b.dy - a.dy;
        });

      // add the link titles
      link.append('title').text(function (d) {
        return d.source.name + ' → ' + d.target.name + '\n' + format(d.value);
      });

      // add in the nodes
      var node = svg
        .append('g')
        .selectAll('.node')
        .data(graph.nodes)
        .enter()
        .append('g')
        .attr('class', 'node')
        .attr('transform', function (d) {
          return 'translate(' + d.x + ',' + d.y + ')';
        })
        .call(
          d3.behavior
            .drag()
            .origin(function (d) {
              return d;
            })
            .on('dragstart', function () {
              this.parentNode.appendChild(this);
            })
            .on('drag', dragmove)
        );

      // add the rectangles for the nodes
      node
        .append('rect')
        .attr('height', function (d) {
          return d.dy;
        })
        .attr('width', sankey.nodeWidth())
        .style('fill', function (d) {
          return (d.color = color(d.name.replace(/ .*/, '')));
        })
        .style('stroke', function (d) {
          return d3.rgb(d.color).darker(2);
        })
        .append('title')
        .text(function (d) {
          return d.name + '\n' + format(d.value);
        });

      // the function for moving the nodes
      function dragmove(d) {
        d3.select(this).attr(
          'transform',
          'translate(' +
            d.x +
            ',' +
            (d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))) +
            ')'
        );
        sankey.relayout();
        link.attr('d', path);
      }
    });
  }
  roundVal(ev) {
    var numb = +ev;
    numb.toFixed(1);
    return numb;
  }
  convVal(ev) {
    var nu = +ev;

    // alert(nu)
    if (nu <= -1) {
      var valnew = 1;
    }
    if (nu > -1 && nu <= 1) {
      var valnew = 2;
    }
    if (nu > 1 && nu <= 5) {
      var valnew = 3;
    }

    if (nu > 5 && nu <= 50) {
      var valnew = 4;
    }
    if (nu > 50 && nu <= 250) {
      var valnew = 5;
    }
    if (nu > 250) {
      var valnew = 6;
    }

    return valnew;
  }

  getCoolingData() {
    return {
      links: [
        { source: 'Cooling Loads(kw)', target: 'Fresh Air', value: '2' },
        { source: 'Cooling Loads(kw)', target: 'Conduction', value: '5' },
        { source: 'Cooling Loads(kw)', target: 'Infiltration', value: '4' },

        { source: 'Cooling Loads(kw)', target: 'Internal Gains', value: '4' },
        { source: 'Cooling Loads(kw)', target: 'Solar Gains', value: '4' },
        { source: 'Conduction', target: 'Internal Conduction', value: '2' },
        { source: 'Conduction', target: 'External Conduction', value: '2' },
        {
          source: 'External Conduction',
          target: this.cooling_loads_external_walls + ' ' + 'External Walls',
          value: this.convVal(this.cooling_loads_external_walls),
        },
        {
          source: 'External Conduction',
          target: this.cooling_loads_windows + ' ' + 'Window',
          value: this.convVal(this.cooling_loads_windows),
        },
        {
          source: 'External Conduction',
          target: this.cooling_loads_floors + ' ' + 'Floor',
          value: this.convVal(this.cooling_loads_floors),
        },
        {
          source: 'External Conduction',
          target: this.cooling_loads_roofs + ' ' + 'Roof',
          value: this.convVal(this.cooling_loads_roofs),
        },
        {
          source: 'Internal Conduction',
          target:
            this.cooling_loads_internal_conduction_gain +
            ' ' +
            'Internal condt.',
          value: this.convVal(this.cooling_loads_internal_conduction_gain),
        },
        {
          source: 'Fresh Air',
          target: this.cooling_loads_Fresh_air_gain + ' ' + 'Fresh Air',
          value: this.convVal(this.cooling_loads_Fresh_air_gain),
        },

        { source: 'Internal Gains', target: 'Internal Sensible', value: '4' },
        {
          source: 'Internal Sensible',
          target: this.cooling_loads_people_gain + ' ' + 'Occupants',
          value: '4',
        },
        {
          source: 'Internal Sensible',
          target: this.cooling_loads_lighting_gain + ' ' + 'Lighting',
          value: this.convVal(this.cooling_loads_lighting_gain),
        },
        {
          source: 'Internal Sensible',
          target: this.cooling_loads_equipment_gain + ' ' + 'Equipment',
          value: this.convVal(this.cooling_loads_equipment_gain),
        },
        {
          source: 'Solar Gains',
          target: this.cooling_loads_solar_gain + ' ' + 'Solar Gains',
          value: this.convVal(this.cooling_loads_solar_gain),
        },
        {
          source: 'Infiltration',
          target: this.cooling_loads_infiltration_gain + ' ' + 'Infiltration',
          value: this.convVal(this.cooling_loads_infiltration_gain),
        },
      ],
      nodes: [
        { name: this.cooling_loads_solar_gain + ' ' + 'Solar Gains' },
        { name: 'Cooling Loads(kw)' },
        { name: 'Fresh Air' },
        { name: 'Conduction' },
        { name: 'Infiltration' },

        { name: 'Internal Gains' },

        { name: 'Internal Sensible' },
        { name: 'Solar Gains' },
        { name: 'Internal Conduction' },
        {
          name:
            this.cooling_loads_internal_conduction_gain +
            ' ' +
            'Internal condt.',
        },
        { name: 'External Conduction' },
        { name: this.cooling_loads_external_walls + ' ' + 'External Walls' },
        { name: this.cooling_loads_floors + ' ' + 'Floor' },
        { name: this.cooling_loads_roofs + ' ' + 'Roof' },
        { name: this.cooling_loads_windows + ' ' + 'Window' },
        { name: this.cooling_loads_Fresh_air_gain + ' ' + 'Fresh Air' },
        { name: this.cooling_loads_infiltration_gain + ' ' + 'Infiltration' },

        { name: this.cooling_loads_people_gain + ' ' + 'Occupants' },
        { name: this.cooling_loads_lighting_gain + ' ' + 'Lighting' },
        { name: this.cooling_loads_equipment_gain + ' ' + 'Equipment' },
      ],
    };
  }

  getData() {
    return {
      links: [
        { source: 'Heating Loads(kw)', target: 'Fresh Air', value: '2' },
        { source: 'Heating Loads(kw)', target: 'Conduction', value: '5' },
        { source: 'Heating Loads(kw)', target: 'Infiltration', value: '4' },

        { source: 'Conduction', target: 'Internal Conduction', value: '2' },
        { source: 'Conduction', target: 'External Conduction', value: '2' },
        {
          source: 'External Conduction',
          target: this.heating_loads_external_walls + ' ' + 'External Walls',
          value: this.convVal(this.heating_loads_external_walls),
        },
        {
          source: 'External Conduction',
          target: this.heating_loads_windows + ' ' + 'Window/Door',
          value: this.convVal(this.heating_loads_windows),
        },
        {
          source: 'External Conduction',
          target: this.heating_loads_floors + ' ' + 'Floor',
          value: this.convVal(this.heating_loads_floors),
        },
        {
          source: 'External Conduction',
          target: this.heating_loads_roofs + ' ' + 'Roof',
          value: this.convVal(this.heating_loads_roofs),
        },
        {
          source: 'Internal Conduction',
          target:
            +this.heating_loads_internal_conduction_gain +
            ' ' +
            '   Internal condt.',
          value: this.convVal(this.heating_loads_internal_conduction_gain),
        },
        {
          source: 'Fresh Air',
          target: this.heating_loads_Fresh_air_gain + ' ' + 'Fresh Air',
          value: this.convVal(this.heating_loads_Fresh_air_gain),
        },

        {
          source: 'Infiltration',
          target: this.heating_loads_infiltration_gain + ' ' + 'Infiltration',
          value: this.convVal(this.heating_loads_infiltration_gain),
        },
      ],
      nodes: [
        { name: 'Heating Loads(kw)' },
        { name: 'Fresh Air' },
        { name: 'Conduction' },
        { name: 'Infiltration' },

        { name: 'Internal Conduction' },
        {
          name:
            +this.heating_loads_internal_conduction_gain +
            ' ' +
            '   Internal condt.',
        },
        { name: 'External Conduction' },
        { name: this.heating_loads_external_walls + ' ' + 'External Walls' },
        { name: this.heating_loads_floors + ' ' + 'Floor' },
        { name: this.heating_loads_roofs + ' ' + 'Roof' },
        { name: this.heating_loads_windows + ' ' + 'Window/Door' },
        { name: this.heating_loads_Fresh_air_gain + ' ' + 'Fresh Air' },
        { name: this.heating_loads_infiltration_gain + ' ' + 'Infiltration' },
      ],
    };
  }

  getDataNoSolarGain() {
    return {
      links: [
        { source: 'Heating Loads(kw)', target: 'Fresh Air', value: '2' },
        { source: 'Heating Loads(kw)', target: 'Conduction', value: '5' },
        { source: 'Heating Loads(kw)', target: 'Infiltration', value: '4' },

        { source: 'Conduction', target: 'Internal Conduction', value: '2' },
        { source: 'Conduction', target: 'External Conduction', value: '2' },
        {
          source: 'External Conduction',
          target: this.stripHTML(
            this.heating_loads_external_walls + ' ' + 'External Walls'
          ),
          value: this.convVal(this.heating_loads_external_walls),
        },
        {
          source: 'External Conduction',
          target: this.stripHTML(
            this.heating_loads_windows + ' ' + 'Window/Door'
          ),
          value: this.convVal(this.heating_loads_windows),
        },
        {
          source: 'External Conduction',
          target: this.stripHTML(this.heating_loads_floors + ' ' + 'Floor'),
          value: this.convVal(this.heating_loads_floors),
        },
        {
          source: 'External Conduction',
          target: this.stripHTML(this.heating_loads_roofs + ' ' + 'Roof'),
          value: this.convVal(this.heating_loads_roofs),
        },
        {
          source: 'Internal Conduction',
          target: this.stripHTML(
            this.heating_loads_internal_conduction_gain +
              ' ' +
              'Internal condt.'
          ),
          value: this.convVal(this.heating_loads_internal_conduction_gain),
        },
        {
          source: 'Fresh Air',
          target: this.stripHTML(
            this.heating_loads_Fresh_air_gain + ' ' + 'Fresh Air'
          ),
          value: this.convVal(this.heating_loads_Fresh_air_gain),
        },

        {
          source: 'Infiltration',
          target: this.stripHTML(
            this.heating_loads_infiltration_gain + ' ' + 'Infiltration'
          ),
          value: this.convVal(this.heating_loads_infiltration_gain),
        },
      ],
      nodes: [
        { name: 'Heating Loads(kw)' },
        { name: 'Fresh Air' },
        { name: 'Conduction' },
        { name: 'Infiltration' },

        { name: 'Internal Conduction' },
        {
          name: this.stripHTML(
            this.heating_loads_internal_conduction_gain +
              ' ' +
              'Internal condt.'
          ),
        },
        { name: 'External Conduction' },
        {
          name: this.stripHTML(
            this.heating_loads_external_walls + ' ' + 'External Walls'
          ),
        },
        { name: this.stripHTML(this.heating_loads_floors + ' ' + 'Floor') },
        { name: this.stripHTML(this.heating_loads_roofs + ' ' + 'Roof') },
        {
          name: this.stripHTML(
            this.heating_loads_windows + ' ' + 'Window/Door'
          ),
        },
        {
          name: this.stripHTML(
            this.heating_loads_Fresh_air_gain + ' ' + 'Fresh Air'
          ),
        },
        {
          name: this.stripHTML(
            this.heating_loads_infiltration_gain + ' ' + 'Infiltration'
          ),
        },
      ],
    };
  }

  sankyGph() {
    d3.sankey = function () {
      var sankey: any = {},
        nodeWidth = 24,
        nodePadding = 8,
        size = [1, 1],
        nodes = [],
        links = [];

      sankey.nodeWidth = function (_) {
        if (!arguments.length) return nodeWidth;
        nodeWidth = +_;
        return sankey;
      };

      sankey.nodePadding = function (_) {
        if (!arguments.length) return nodePadding;
        nodePadding = +_;
        return sankey;
      };

      sankey.nodes = function (_) {
        if (!arguments.length) return nodes;
        nodes = _;
        return sankey;
      };

      sankey.links = function (_) {
        if (!arguments.length) return links;
        links = _;
        return sankey;
      };

      sankey.size = function (_) {
        if (!arguments.length) return size;
        size = _;
        return sankey;
      };

      sankey.layout = function (iterations) {
        computeNodeLinks();
        computeNodeValues();
        computeNodeBreadths();
        computeNodeDepths(iterations);
        computeLinkDepths();
        return sankey;
      };

      sankey.relayout = function () {
        computeLinkDepths();
        return sankey;
      };

      sankey.link = function () {
        var curvature = 0.5;

        function link(d) {
          var x0 = d.source.x + d.source.dx,
            x1 = d.target.x,
            xi = d3.interpolateNumber(x0, x1),
            x2 = xi(curvature),
            x3 = xi(1 - curvature),
            y0 = d.source.y + d.sy + d.dy / 2,
            y1 = d.target.y + d.ty + d.dy / 2;
          return (
            'M' +
            x0 +
            ',' +
            y0 +
            'C' +
            x2 +
            ',' +
            y0 +
            ' ' +
            x3 +
            ',' +
            y1 +
            ' ' +
            x1 +
            ',' +
            y1
          );
        }

        /* link.curvature = function(_) {
          if (!arguments.length) return curvature;
          curvature = +_;
          return link;
        };
     */
        return link;
      };

      // Populate the sourceLinks and targetLinks for each node.
      // Also, if the source and target are not objects, assume they are indices.
      function computeNodeLinks() {
        nodes.forEach(function (node) {
          node.sourceLinks = [];
          node.targetLinks = [];
        });
        links.forEach(function (link) {
          var source = link.source,
            target = link.target;
          if (typeof source === 'number')
            source = link.source = nodes[link.source];
          if (typeof target === 'number')
            target = link.target = nodes[link.target];
          source.sourceLinks.push(link);
          target.targetLinks.push(link);
        });
      }

      // Compute the value (size) of each node by summing the associated links.
      function computeNodeValues() {
        nodes.forEach(function (node) {
          node.value = Math.max(
            d3.sum(node.sourceLinks, value),
            d3.sum(node.targetLinks, value)
          );
        });
      }

      // Iteratively assign the breadth (x-position) for each node.
      // Nodes are assigned the maximum breadth of incoming neighbors plus one;
      // nodes with no incoming links are assigned breadth zero, while
      // nodes with no outgoing links are assigned the maximum breadth.
      function computeNodeBreadths() {
        var remainingNodes = nodes,
          nextNodes,
          x = 0;

        while (remainingNodes.length) {
          nextNodes = [];
          remainingNodes.forEach(function (node) {
            node.x = x;
            node.dx = nodeWidth;
            node.sourceLinks.forEach(function (link) {
              nextNodes.push(link.target);
            });
          });
          remainingNodes = nextNodes;
          ++x;
        }

        //
        moveSinksRight(x);
        scaleNodeBreadths((width - nodeWidth) / (x - 1));
      }

      function moveSourcesRight() {
        nodes.forEach(function (node) {
          if (!node.targetLinks.length) {
            node.x =
              d3.min(node.sourceLinks, function (d) {
                return d.target.x;
              }) - 1;
          }
        });
      }

      function moveSinksRight(x) {
        nodes.forEach(function (node) {
          if (!node.sourceLinks.length) {
            node.x = x - 1;
          }
        });
      }

      function scaleNodeBreadths(kx) {
        nodes.forEach(function (node) {
          node.x *= kx;
        });
      }

      function computeNodeDepths(iterations) {
        var nodesByBreadth = d3
          .nest()
          .key(function (d) {
            return d.x;
          })
          .sortKeys(d3.ascending)
          .entries(nodes)
          .map(function (d) {
            return d.values;
          });

        //
        initializeNodeDepth();
        resolveCollisions();
        for (var alpha = 1; iterations > 0; --iterations) {
          relaxRightToLeft((alpha *= 0.99));
          resolveCollisions();
          relaxLeftToRight(alpha);
          resolveCollisions();
        }

        function initializeNodeDepth() {
          var ky = d3.min(nodesByBreadth, function (nodes) {
            return (
              (size[1] - (nodes.length - 1) * nodePadding) /
              d3.sum(nodes, value)
            );
          });

          nodesByBreadth.forEach(function (nodes) {
            nodes.forEach(function (node, i) {
              node.y = i;
              node.dy = node.value * ky;
            });
          });

          links.forEach(function (link) {
            link.dy = link.value * ky;
          });
        }

        function relaxLeftToRight(alpha) {
          nodesByBreadth.forEach(function (nodes, breadth) {
            nodes.forEach(function (node) {
              if (node.targetLinks.length) {
                var y =
                  d3.sum(node.targetLinks, weightedSource) /
                  d3.sum(node.targetLinks, value);
                node.y += (y - center(node)) * alpha;
              }
            });
          });

          function weightedSource(link) {
            return center(link.source) * link.value;
          }
        }

        function relaxRightToLeft(alpha) {
          nodesByBreadth
            .slice()
            .reverse()
            .forEach(function (nodes) {
              nodes.forEach(function (node) {
                if (node.sourceLinks.length) {
                  var y =
                    d3.sum(node.sourceLinks, weightedTarget) /
                    d3.sum(node.sourceLinks, value);
                  node.y += (y - center(node)) * alpha;
                }
              });
            });

          function weightedTarget(link) {
            return center(link.target) * link.value;
          }
        }

        function resolveCollisions() {
          nodesByBreadth.forEach(function (nodes) {
            var node,
              dy,
              y0 = 0,
              n = nodes.length,
              i;

            // Push any overlapping nodes down.
            nodes.sort(ascendingDepth);
            for (i = 0; i < n; ++i) {
              node = nodes[i];
              dy = y0 - node.y;
              if (dy > 0) node.y += dy;
              y0 = node.y + node.dy + nodePadding;
            }

            // If the bottommost node goes outside the bounds, push it back up.
            dy = y0 - nodePadding - size[1];
            if (dy > 0) {
              y0 = node.y -= dy;

              // Push any overlapping nodes back up.
              for (i = n - 2; i >= 0; --i) {
                node = nodes[i];
                dy = node.y + node.dy + nodePadding - y0;
                if (dy > 0) node.y -= dy;
                y0 = node.y;
              }
            }
          });
        }

        function ascendingDepth(a, b) {
          return a.y - b.y;
        }
      }

      function computeLinkDepths() {
        nodes.forEach(function (node) {
          node.sourceLinks.sort(ascendingTargetDepth);
          node.targetLinks.sort(ascendingSourceDepth);
        });
        nodes.forEach(function (node) {
          var sy = 0,
            ty = 0;
          node.sourceLinks.forEach(function (link) {
            link.sy = sy;
            sy += link.dy;
          });
          node.targetLinks.forEach(function (link) {
            link.ty = ty;
            ty += link.dy;
          });
        });

        function ascendingSourceDepth(a, b) {
          return a.source.y - b.source.y;
        }

        function ascendingTargetDepth(a, b) {
          return a.target.y - b.target.y;
        }
      }

      function center(node) {
        return node.y + node.dy / 2;
      }

      function value(link) {
        return link.value;
      }

      return sankey;
    };

    //sankeylib below

    var units = 'units';

    var margin = { top: 10, right: 10, bottom: 10, left: 10 },
      width = 500 - margin.left - margin.right,
      height = 340 - margin.top - margin.bottom;

    var formatNumber = d3.format(',.0f'), // zero decimal places
      format = function (d) {
        return formatNumber(d) + ' ' + units;
      },
      color = d3.scale.category20();

    // append the svg canvas to the page
    var svg = d3
      .select('#chartsix')
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    // Set the sankey diagram properties
    var sankey = d3
      .sankey()
      .nodeWidth(36)
      .nodePadding(10)
      .size([width, height]);

    var path = sankey.link();

    var graph: any = this.getDataNoSolarGain();

    var nodeMap = {};
    graph.nodes.forEach(function (x) {
      nodeMap[x.name] = x;
    });
    graph.links = graph.links.map(function (x) {
      return {
        source: nodeMap[x.source],
        target: nodeMap[x.target],
        value: x.value,
      };
    });

    sankey.nodes(graph.nodes).links(graph.links).layout(32);

    // add in the links
    var link = svg
      .append('g')
      .selectAll('.link')
      .data(graph.links)
      .enter()
      .append('path')
      .attr('class', 'link')
      .attr('d', path)
      .style('stroke-width', function (d) {
        return Math.max(1, d.dy);
      })
      .style('fill', 'none')
      .sort(function (a, b) {
        return b.dy - a.dy;
      });

    // add the link titles
    link.append('title').text(function (d) {
      return d.source.name + ' → ' + d.target.name + '\n' + format(d.value);
    });

    // add in the nodes
    var node = svg
      .append('g')
      .selectAll('.node')

      .data(graph.nodes)
      .enter()
      .append('g')
      .attr('class', 'node')
      .attr('transform', function (d) {
        /* var dx = d.x;
             if(d.x > 1200){
               dx - 600
             } */
        return 'translate(' + d.x + ',' + d.y + ')';
      })
      .call(
        d3.behavior
          .drag()
          .origin(function (d) {
            return d;
          })
          .on('dragstart', function () {
            this.parentNode.appendChild(this);
          })
          .on('drag', dragmove)
      );
    /* .call(function () {
           manualLayout();
         });
       */
    // add the rectangles for the nodes
    node
      .append('rect')
      .attr('height', function (d) {
        return d.dy;
      })
      .attr('width', sankey.nodeWidth())
      .style('fill', function (d) {
        if (d.name === 'Heating Loads(kw)') {
          return '#d62728';
        } else if (d.name.indexOf('Infiltration') > -1) {
        /*  else if(d.name == "Infiltration"){
              return "#d62766"
             } */
          return '#2D9AFE';
        } else if (d.name.indexOf('Fresh Air') > -1) {
          return '#95D23E';
        } else return (d.color = color(d.name.replace(/ .*/, '')));
      })
      .style('stroke', function (d) {
        return d3.rgb(d.color).darker(2);
      })
      .append('title')
      .text(function (d) {
        return d.name + '\n' + format(d.value);
      });

    // add in the title for the nodes
    node
      .append('text')
      .attr('x', -6)
      .attr('y', function (d) {
        return d.dy / 2;
      })
      .attr('dy', '.35em')
      .attr('text-anchor', 'end')
      .attr('transform', null)
      .style('font-size', '12px')
      .text(function (d) {
        return d.name;
      })
      //    .filter(function(d) { return d.x < width / 2; })
      .attr('x', 6 + sankey.nodeWidth())
      .attr('text-anchor', 'start');

    // the function for moving the nodes
    function dragmove(d) {
      // if(d.name =="Conduction") {
      if (d.x !== 544) {
        d3.select(this).attr(
          'transform',
          'translate(' +
            (d.x = Math.max(0, Math.min(width - d.dx, d3.event.x))) +
            ',' +
            (d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))) +
            ')'
        );
      }

      if (d.name == 'Internal Conduction') {
        d3.select(this).attr(
          'transform',
          'translate(' +
            (d.x = Math.max(0, Math.min(width - d.dx, d3.event.x))) +
            ',' +
            (d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))) +
            ')'
        );
      }
      if (d.name == 'Heating Loads(kw)') {
        d3.select(this).attr(
          'transform',
          'translate(' +
            (d.x = Math.max(0, Math.min(width - 600 - d.dx, d3.event.x))) +
            ',' +
            (d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))) +
            ')'
        );
      }
      sankey.relayout();
      link.attr('d', path);
    }
    // manually customize node position
    function manualLayout() {
      //http://stackoverflow.com/questions/10337640/how-to-access-the-dom-element-that-correlates-to-a-d3-svg-object
      //displacements in order of foo nodes (foo[0][j])
      var displacements = [
        56, 299, 485, 647, 766, 55, 746, 307, 490, 612, 677, 429,
      ];
      var foo = d3.selectAll('g.node');

      for (j = 0; j < displacements.length; j++) {
        pickNode = foo[0][j]; //equals "this" in d3.behavior.drag()...on("dragstart")
        d = graph.nodes[j];

        d3.select(pickNode).attr(
          'transform',
          'translate(' +
            (d.x = d.x) +
            ',' +
            (d.y = displacements[j]) + //Math.max(0, Math.min(height - d.dy, d3.event.y))
            ')'
        );
      }
      sankey.relayout();
      link.attr('d', path);
    }

    // this.convVal(this.cooling_loads_internal_conduction_gain)
  }

  coolingSnk() {
    var units = 'units';

    var margin = { top: 10, right: 10, bottom: 10, left: 10 },
      width = 500 - margin.left - margin.right,
      height = 240 - margin.top - margin.bottom;

    var formatNumber = d3.format(',.0f'), // zero decimal places
      format = function (d) {
        return formatNumber(d) + ' ' + units;
      },
      color = d3.scale.category20();

    // append the svg canvas to the page
    var svg = d3
      .select('#chartcooling')
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    // Set the sankey diagram properties
    var sankey = d3
      .sankey()
      .nodeWidth(36)
      .nodePadding(10)
      .size([width, height]);

    var path = sankey.link();

    // load the data
    // d3.json( "assets/sankey.json", function(error, graph) {
    var graph: any = this.getCoolingData();
    var nodeMap = {};
    graph.nodes.forEach(function (x) {
      nodeMap[x.name] = x;
    });
    graph.links = graph.links.map(function (x) {
      return {
        source: nodeMap[x.source],
        target: nodeMap[x.target],
        value: x.value,
      };
    });

    sankey.nodes(graph.nodes).links(graph.links).layout(32);
    // add in the links
    var link = svg
      .append('g')
      .selectAll('.link')
      .data(graph.links)
      .enter()
      .append('path')
      .attr('class', 'link')
      .attr('d', path)
      .style('stroke-width', function (d) {
        return Math.max(1, d.dy);
      })
      .sort(function (a, b) {
        return b.dy - a.dy;
      });

    // add the link titles
    link.append('title').text(function (d) {
      return d.source.name + ' → ' + d.target.name + '\n' + format(d.value);
    });

    // add in the nodes
    var node = svg
      .append('g')
      .selectAll('.node')

      .data(graph.nodes)
      .enter()
      .append('g')
      .attr('class', 'node')

      .attr('transform', function (d) {
        return 'translate(' + d.x + ',' + d.y + ')';
      })
      .call(
        d3.behavior
          .drag()
          .origin(function (d) {
            return d;
          })
          .on('dragstart', function () {
            this.parentNode.appendChild(this);
          })
          .on('drag', dragmove)
      );
    /* .call(function () {
           manualLayout();
         });
       */
    // add the rectangles for the nodes
    node
      .append('rect')
      .attr('height', function (d) {
        return d.dy;
      })
      .attr('width', sankey.nodeWidth())
      .style('fill', function (d) {
        if (d.name === 'Cooling Loads(kw)') {
          return '#6F57EA';
        }  else if (d.name.indexOf('Solar Gains') > -1) {
        /*  else if(d.name == "Infiltration"){
              return "#d62766"
             } */
          return '#2D9AFE';
        } else if (d.name.indexOf('Fresh Air') > -1) {
          return '#95D23E';
        }else return (d.color = color(d.name.replace(/ .*/, '')));
      })
      .append('title')
      .text(function (d) {
        return d.name + '\n' + format(d.value);
      });

    // add in the title for the nodes
    node
      .append('text')
      .attr('x', -6)
      .attr('y', function (d) {
        return d.dy / 2;
      })
      .attr('dy', '.35em')
      .attr('text-anchor', 'end')
      .attr('transform', null)
      .style('font-size', '12px')
      .text(function (d) {
        return d.name;
      })
      // .filter(function(d) { return d.x < width / 2; })
      .attr('x', 6 + sankey.nodeWidth())
      .attr('text-anchor', 'start');

    // the function for moving the nodes
    function dragmove(d) {
      if (d.x !== 544) {
        d3.select(this).attr(
          'transform',
          'translate(' +
            (d.x = Math.max(0, Math.min(width - d.dx, d3.event.x))) +
            ',' +
            (d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))) +
            ')'
        );
      }

      if (d.name == 'Internal Conduction') {
        d3.select(this).attr(
          'transform',
          'translate(' +
            (d.x = Math.max(0, Math.min(width - d.dx, d3.event.x))) +
            ',' +
            (d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))) +
            ')'
        );
      }
      if (d.name == 'Cooling Loads(kw)') {
        d3.select(this).attr(
          'transform',
          'translate(' +
            (d.x = Math.max(0, Math.min(width - 600 - d.dx, d3.event.x))) +
            ',' +
            (d.y = 135) +
            ')'
        );
      }
      sankey.relayout();
      link.attr('d', path);
    }
    // manually customize node position
    function manualLayout() {
      //http://stackoverflow.com/questions/10337640/how-to-access-the-dom-element-that-correlates-to-a-d3-svg-object
      //displacements in order of foo nodes (foo[0][j])
      var displacements = [
        56, 299, 485, 647, 766, 55, 746, 307, 490, 612, 677, 429,
      ];
      var foo = d3.selectAll('g.node');

      for (j = 0; j < displacements.length; j++) {
        pickNode = foo[0][j]; //equals "this" in d3.behavior.drag()...on("dragstart")
        d = graph.nodes[j];

        d3.select(pickNode).attr(
          'transform',
          'translate(' +
            (d.x = d.x) +
            ',' +
            (d.y = displacements[j]) + //Math.max(0, Math.min(height - d.dy, d3.event.y))
            ')'
        );
      }
      sankey.relayout();
      link.attr('d', path);
    }
  }

  // heating sankey with solar gains

  heatingSnk() {
    var units = 'units';

    var margin = { top: 10, right: 10, bottom: 10, left: 10 },
      width = 500 - margin.left - margin.right,
      height = 240 - margin.top - margin.bottom;

    var formatNumber = d3.format(',.0f'), // zero decimal places
      format = function (d) {
        return formatNumber(d) + ' ' + units;
      },
      color = d3.scale.category20();

    // append the svg canvas to the page
    var svg = d3
      .select('#heating')
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    // Set the sankey diagram properties
    var sankey = d3
      .sankey()
      .nodeWidth(36)
      .nodePadding(10)
      .size([width, height]);

    var path = sankey.link();

    // load the data
    // d3.json( "assets/sankey.json", function(error, graph) {
    var graph: any = this.getData();
    var nodeMap = {};
    graph.nodes.forEach(function (x) {
      nodeMap[x.name] = x;
    });
    graph.links = graph.links.map(function (x) {
      return {
        source: nodeMap[x.source],
        target: nodeMap[x.target],
        value: x.value,
      };
    });

    sankey.nodes(graph.nodes).links(graph.links).layout(32);
    // add in the links
    var link = svg
      .append('g')
      .selectAll('.link')
      .data(graph.links)
      .enter()
      .append('path')
      .attr('class', 'link')
      .attr('d', path)
      .style('fill', 'none')
      .style('stroke-width', function (d) {
        return Math.max(1, d.dy);
      })
      .sort(function (a, b) {
        return b.dy - a.dy;
      });

    // add the link titles
    link.append('title').text(function (d) {
      return d.source.name + ' → ' + d.target.name + '\n' + format(d.value);
    });

    // add in the nodes
    var node = svg
      .append('g')
      .selectAll('.node')

      .data(graph.nodes)
      .enter()
      .append('g')
      .attr('class', 'node')

      .attr('transform', function (d) {
        return 'translate(' + d.x + ',' + d.y + ')';
      })
      .call(
        d3.behavior
          .drag()
          .origin(function (d) {
            return d;
          })
          .on('dragstart', function () {
            this.parentNode.appendChild(this);
          })
          .on('drag', dragmove)
      );
    /* .call(function () {
           manualLayout();
         });
       */
    // add the rectangles for the nodes
    node
      .append('rect')
      .attr('height', function (d) {
        return d.dy;
      })
      .attr('width', sankey.nodeWidth())
      .style('fill', function (d) {
        if (d.name === 'Heating Loads(kw)') {
          return '#6F57EA';
        } else if (d.name.indexOf('Infiltration') > -1) {
        /*  else if(d.name == "Infiltration"){
              return "#d62766"
             } */
          return '#2D9AFE';
        } else if (d.name.indexOf('Fresh Air') > -1) {
          return '#95D23E';
        } else if (d.name.indexOf('Solar Gains') > -1) {
          return '#EA5D84';
        } else if (d.name.indexOf('Solar Gains') > -1) {
          return '#EA5D84';
        }else return (d.color = color(d.name.replace(/ .*/, '')));
      })
     
      .append('title')
      .text(function (d) {
        return d.name + '\n' + format(d.value);
      });

    // add in the title for the nodes
    node
      .append('text')
      .attr('x', -6)
      .attr('y', function (d) {
        return d.dy / 2;
      })
      .attr('dy', '.35em')
      .attr('text-anchor', 'end')
      .attr('transform', null)
      .style('font-size', '12px')
      .text(function (d) {
        return d.name;
      })
      // .filter(function(d) { return d.x < width / 2; })
      .attr('x', 6 + sankey.nodeWidth())
      .attr('text-anchor', 'start');

    // the function for moving the nodes
    function dragmove(d) {
      if (d.x !== 544) {
        d3.select(this).attr(
          'transform',
          'translate(' +
            (d.x = Math.max(0, Math.min(width - d.dx, d3.event.x))) +
            ',' +
            (d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))) +
            ')'
        );
      }

      if (d.name == 'Internal Conduction') {
        d3.select(this).attr(
          'transform',
          'translate(' +
            (d.x = Math.max(0, Math.min(width - d.dx, d3.event.x))) +
            ',' +
            (d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))) +
            ')'
        );
      }
      if (d.name == 'Heating Loads(kw)') {
        d3.select(this).attr(
          'transform',
          'translate(' +
            (d.x = Math.max(0, Math.min(width - 600 - d.dx, d3.event.x))) +
            ',' +
            (d.y = 95) +
            ')'
        );
      }
      sankey.relayout();
      link.attr('d', path);
    }
    // manually customize node position
    function manualLayout() {
      //http://stackoverflow.com/questions/10337640/how-to-access-the-dom-element-that-correlates-to-a-d3-svg-object
      //displacements in order of foo nodes (foo[0][j])
      var displacements = [
        56, 299, 485, 647, 766, 55, 746, 307, 490, 612, 677, 429,
      ];
      var foo = d3.selectAll('g.node');

      for (j = 0; j < displacements.length; j++) {
        pickNode = foo[0][j]; //equals "this" in d3.behavior.drag()...on("dragstart")
        d = graph.nodes[j];

        d3.select(pickNode).attr(
          'transform',
          'translate(' +
            (d.x = d.x) +
            ',' +
            (d.y = displacements[j]) + //Math.max(0, Math.min(height - d.dy, d3.event.y))
            ')'
        );
      }
      sankey.relayout();
      link.attr('d', path);
    }
  }

  // heating sankey with solar gain end

  proSnkapi() {
    this.authService.proSankey().subscribe((data) => {
      this.cellSevenmessage;
      // var lst = this.cellSevenmessage.pop()
      this.proSnkGraph = data;

      // this.celsev = this.cellSevenmessage

      var lastChar = this.cellSevenmessage.toString().slice(-1);
      var newsevenmsg = this.cellSevenmessage;
      if (lastChar == '0') {
        //this.cellSevenmessage[this.cellSevenmessage -1]
        var ghf = newsevenmsg.slice(0, -1);
      } else {
        var ghf = newsevenmsg;
      }

      var nert = this.proSnkGraph.loadResults ? this.proSnkGraph.loadResults.filter((data) => Number(data.WWR) == ghf) : [];
      if (this.proSnkGraph.success == '1') {
        this.apiloaded = true;
        this.heating_loads_roofs = +nert[0].heating_loads_roofs;
        this.heating_loads_floors = +nert[0].heating_loads_floors;
        this.heating_loads_internal_conduction_gain =
          +nert[0].heating_loads_internal_conduction_gain;
        this.heating_loads_external_walls =
          +nert[0].heating_loads_external_walls;
        this.heating_loads_windows = +nert[0].heating_loads_windows;
        this.heating_loads_Fresh_air_gain =
          +nert[0].heating_loads_Fresh_air_gain;
        this.heating_loads_infiltration_gain =
          +nert[0].heating_loads_infiltration_gain;
        //this.heating_loads_solar_gain = +nert[0].heating_loads_solar_gain;
        //this.heating_loads_equipment_gain = +nert[0].heating_loads_equipment_gain;
        //this.heating_loads_lighting_gain = +nert[0].heating_loads_lighting_gain;
        //this.heating_loads_internal_conduction_gain = this.heating_loads_internal_conduction_gain.toFixed(2);
        // this.heating_loads_internal_conduction_gain.toFixed(2)

        this.total_heating_load =
          this.heating_loads_roofs +
          this.heating_loads_floors +
          this.heating_loads_internal_conduction_gain +
          this.heating_loads_external_walls +
          this.heating_loads_windows +
          this.heating_loads_Fresh_air_gain +
          this.heating_loads_infiltration_gain;

        //alert(typeof this.heating_loads_roofs)
        //  document.getElementById("heating_load").innerHTML = this.total_heating_load
        // this.sankyGph();

        this.cooling_loads_roofs = nert[0].cooling_loads_roofs;
        this.cooling_loads_floors = nert[0].cooling_loads_floors;
        this.cooling_loads_internal_conduction_gain =
          nert[0].cooling_loads_internal_conduction_gain;
        this.cooling_loads_external_walls =
          nert[0].cooling_loads_external_walls;
        this.cooling_loads_windows = nert[0].cooling_loads_windows;
        this.cooling_loads_Fresh_air_gain =
          nert[0].cooling_loads_Fresh_air_gain;
        this.cooling_loads_infiltration_gain =
          nert[0].cooling_loads_infiltration_gain;
        this.cooling_loads_solar_gain = nert[0].cooling_loads_solar_gain;
        this.cooling_loads_equipment_gain =
          nert[0].cooling_loads_equipment_gain;
        this.cooling_loads_lighting_gain = nert[0].cooling_loads_lighting_gain;
        this.cooling_loads_people_gain = nert[0].cooling_loads_people_gain;

        this.total_cooling_load =
          +this.cooling_loads_roofs +
          +this.cooling_loads_floors +
          +this.cooling_loads_internal_conduction_gain +
          +this.cooling_loads_external_walls +
          +this.cooling_loads_windows +
          +this.cooling_loads_Fresh_air_gain +
          +this.cooling_loads_infiltration_gain +
          +this.cooling_loads_solar_gain +
          +this.cooling_loads_equipment_gain +
          +this.cooling_loads_lighting_gain +
          +this.cooling_loads_people_gain;

        this.sankyGph();

        this.coolingSnk();

        this.heatingSnk();
      }
    });
  }

  optChange() {
    // document.getElementById('snkcharts').innerHTML="";
    //  setTimeout(() =>  this.proSnkapi(), 5000)

    this.authService.proSankey().subscribe((data) => {
      this.proSnkGraph = data;
      //  this.proSnkGraph.filter( res => res.WWR == this.cellSevenmessage  )
      if (this.proSnkGraph.success == '1') {
        this.apiloaded = true;
        this.heating_loads_roofs =
          +this.proSnkGraph.loadResults[0].heating_loads_roofs;
        this.heating_loads_floors =
          +this.proSnkGraph.loadResults[0].heating_loads_floors;
        this.heating_loads_internal_conduction_gain =
          +this.proSnkGraph.loadResults[0]
            .heating_loads_internal_conduction_gain;
        this.heating_loads_external_walls =
          +this.proSnkGraph.loadResults[0].heating_loads_external_walls;
        this.heating_loads_windows =
          +this.proSnkGraph.loadResults[0].heating_loads_windows;
        this.heating_loads_Fresh_air_gain =
          +this.proSnkGraph.loadResults[0].heating_loads_Fresh_air_gain;
        this.heating_loads_infiltration_gain =
          +this.proSnkGraph.loadResults[0].heating_loads_infiltration_gain;
        this.heating_loads_solar_gain =
          +this.proSnkGraph.loadResults[0].heating_loads_solar_gain;
        this.heating_loads_equipment_gain =
          +this.proSnkGraph.loadResults[0].heating_loads_equipment_gain;
        this.heating_loads_lighting_gain =
          +this.proSnkGraph.loadResults[0].heating_loads_lighting_gain;
        //this.heating_loads_internal_conduction_gain = this.heating_loads_internal_conduction_gain.toFixed(2);
        this.total_heating_load =
          this.heating_loads_roofs +
          this.heating_loads_floors +
          this.heating_loads_internal_conduction_gain +
          this.heating_loads_external_walls +
          this.heating_loads_windows +
          this.heating_loads_Fresh_air_gain +
          this.heating_loads_infiltration_gain +
          this.heating_loads_solar_gain +
          this.heating_loads_equipment_gain +
          this.heating_loads_lighting_gain;

        //alert(typeof this.heating_loads_roofs)
        //  document.getElementById("heating_load").innerHTML = this.total_heating_load
        // this.sankyGph();

        this.cooling_loads_roofs =
          this.proSnkGraph.loadResults[0].cooling_loads_roofs;
        this.cooling_loads_floors =
          this.proSnkGraph.loadResults[0].cooling_loads_floors;
        this.cooling_loads_internal_conduction_gain =
          this.proSnkGraph.loadResults[0].cooling_loads_internal_conduction_gain;
        this.cooling_loads_external_walls =
          this.proSnkGraph.loadResults[0].cooling_loads_external_walls;
        this.cooling_loads_windows =
          this.proSnkGraph.loadResults[0].cooling_loads_windows;
        this.cooling_loads_Fresh_air_gain =
          this.proSnkGraph.loadResults[0].cooling_loads_Fresh_air_gain;
        this.cooling_loads_infiltration_gain =
          this.proSnkGraph.loadResults[0].cooling_loads_infiltration_gain;
        this.cooling_loads_solar_gain =
          this.proSnkGraph.loadResults[0].cooling_loads_solar_gain;
        this.cooling_loads_equipment_gain =
          this.proSnkGraph.loadResults[0].cooling_loads_equipment_gain;
        this.cooling_loads_lighting_gain =
          this.proSnkGraph.loadResults[0].cooling_loads_lighting_gain;

        this.total_cooling_load =
          +this.cooling_loads_roofs +
          +this.cooling_loads_floors +
          +this.cooling_loads_internal_conduction_gain +
          +this.cooling_loads_external_walls +
          +this.cooling_loads_windows +
          +this.cooling_loads_Fresh_air_gain +
          +this.cooling_loads_infiltration_gain +
          +this.cooling_loads_solar_gain +
          +this.cooling_loads_equipment_gain +
          +this.cooling_loads_lighting_gain;

        //this.sankyGph()

        this.coolingSnk()

        this.heatingSnk()
      }
    });
  }

  ngOnInit() {
    /* const bodynew = new HttpParams().set('user_id', "62")
    .set('proj_id', "275")
    .set('wall', "W1")
    .set('roof',"R1")
    .set('floor', "F1")
    .set('window',"WIN01")
    .set('shading',"NO")
    .set('lighting',"LPD2")
    
    .set('wwr',"0.1")
    .set('dl',"DLON")
    .set('hvac', "01_ASHP")
    .set('heatRecovery',"'N'")
    this.http.post(this.rootDomainUrl + 'adeos/api/for_dashboard_chart_search.php',bodynew )
      .subscribe((data) => {
      

       
      
     }) */

    document.getElementById('coolingdivider').style.display = 'none';
    document.getElementById('chartsix').style.display = 'none';
    document.getElementById('chartcooling').style.display = 'none';
    document.getElementById('coolingLoad').style.display = 'none';
    // Google Sankey
    document.getElementById('heating').style.display = 'block';
    //document.getElementById('heating').style.display = 'none';

    this.authService.currentMesgcellOneMsg.subscribe(
      (cellmessage) => (this.cellmessage = cellmessage)
    );

    this.authService.currentMesgcellSevenMsg.subscribe(
      (cellSevenmessage) => (this.cellSevenmessage = cellSevenmessage)
    );
   
    this.snkString = JSON.stringify(this.snkGraphJson);
    
  }

  chartCooling() {
    document.getElementById('coolingbtn').style.borderRadius =
      '6px 6px 0px 0px';
	document.getElementById('coolingbtn').style.border = '1px solid #ccc';
    document.getElementById('coolingbtn').style.borderBottom = 'none';
    document.getElementById('coolingbtn').style.color = '#000';
    document.getElementById('heatingbtn').style.backgroundColor = '#fff';
    document.getElementById('heatingbtn').style.color = '#4682b4';
    document.getElementById('heatingbtn').style.border = 'none';
    document.getElementById('heatingbtn').style.borderBottom = '1px solid #ccc';
	
	

    document.getElementById('heatingLoad').style.display = 'none';
    // Google Sankey enable block
    document.getElementById('coolingdivider').style.display = 'block';
    document.getElementById('chartsix').style.display = 'none';
    // Google Sankey enable block
    document.getElementById('chartcooling').style.display = 'block';
    // Google Sankey enable block
    document.getElementById('coolingLoad').style.display = 'block';
    document.getElementById('heating').style.display = 'none';
    document.getElementById('heatingdivider').style.display = 'none';
  }
}
